import "core-js/modules/es.number.constructor.js";
import moment from 'moment-timezone';
export default {
  name: 'dateRange',
  props: {
    startDate: [String, Object],
    endDate: [String, Object],
    dateformat: {
      type: Number,
      default: 0
    },
    allowClear: true
  },
  data: function data() {
    return {
      showTime: false,
      dateformatvalue: "YYYY-MM-DD",
      dateRange: {
        startDateClone: this.startDate,
        endDateClone: this.endDate
      }
    };
  },
  watch: {
    // 'dateformat'(){
    // 	console.log(this.dateformat)
    // 	if(dateformat!=0){
    // 		this.showTime=true
    // 		this.dateformatvalue="YYYY-MM-DD HH:mm"
    // 	}

    // }
  },
  created: function created() {
    if (this.dateformat != 0) {
      this.showTime = true;
      this.dateformatvalue = "YYYY-MM-DD HH:mm";
    }
    // console.log(this.dateformat)
  },
  methods: {
    changeStartDate: function changeStartDate(date) {
      this.dateRange.startDateClone = date;
      this.$emit('change', this.dateRange);
    },
    changeEndDate: function changeEndDate(date) {
      this.dateRange.endDateClone = date;
      this.$emit('change', this.dateRange);
    },
    disabledStartDate: function disabledStartDate(startValue) {
      //  const endValue = this.dateRange.endDateClone;
      //  if (!startValue || !endValue) {
      // return false;
      //  }
      // return startValue.valueOf() >= endValue.valueOf();
      return false;
    },
    disabledEndDate: function disabledEndDate(endValue) {
      //  const startValue = this.dateRange.startDateClone;
      //  if (!endValue || !startValue) {
      // return false;
      //  }
      // return startValue.valueOf() > endValue.valueOf();
      return false;
    },
    handleChange: function handleChange(e) {
      var value = e.target.value;
      this.value = value;
    },
    check: function check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit: function edit() {
      this.editable = true;
    },
    clear: function clear() {
      this.dateRange.startDateClone = '';
      this.dateRange.endDateClone = '';
    }
  }
};